import React from 'react'
import styles from '../styles/pbutton.module.css'

const ProminentButton = ({text}) => {
    return (
        <div className={styles.prominentButton}>{text}</div>
    )
}

export default ProminentButton